import { CharitraService, Ltype, Pagination, LAccordion, LeelaInputParameters } from './charitra.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AccordionVM } from '../accordion/accordion.model';
import { Observable, Observer, delay, pipe, filter, combineLatest, EMPTY, Subject, BehaviorSubject, of, forkJoin, merge, interval } from 'rxjs';
import { Component, OnInit, Pipe, PipeTransform, Input, HostListener } from '@angular/core';
import { tap, map, switchMap, scan, mapTo, distinctUntilChanged, reduce, mergeAll, exhaustMap, expand, mergeMap, concatMap } from 'rxjs/operators';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-charitra',
  templateUrl: './charitra.component.html',
  styleUrls: ['./charitra.component.css']
})
export class CharitraComponent implements OnInit {
  title: any;
  ltype: any;
  leelas = new Observable<AccordionVM[]>();
  input = new LeelaInputParameters();
  leelaLocal = new BehaviorSubject<AccordionVM[]>([]);
  nextDataAvailable = new BehaviorSubject<boolean>(false);
  inProgress = new BehaviorSubject<boolean>(false);

  constructor(private charitraService: CharitraService, private router: Router, private route: ActivatedRoute,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.leelas = this.leelaLocal;
    const type = this.route.snapshot.paramMap.get('ctype')?.toString();

    if (type == "purvardha") {
      this.metaManager.updateMetaTitle("लीळाचरित्र पूर्वार्ध | Mahanubhav Leelacharitra Purvardha | sarvadhnya.com",
        "Mahanubhav Panth Leelacharitra (लीळाचरित्र पूर्वार्ध) - Easy access to Leelacharitra books, read online, search by any keyword",
        "लीळाचरित्र पूर्वार्ध, लीळाचरित्र, leelacharitra purvardha, leelacharitra uttarardha, leelacharitra adnyat, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Purvardha_charitra;
      this.title = "लीळाचरित्र पूर्वार्ध";
    }
    else if (type == "uttarardha") {
      this.metaManager.updateMetaTitle("लीळाचरित्र उत्तरार्ध | Mahanubhav Leelacharitra Uttarardha | sarvadhnya.com",
        "Mahanubhav Panth Leelacharitra (लीळाचरित्र उत्तरार्ध) - Easy access to Leelacharitra books, read online, search by any keyword",
        "लीळाचरित्र उत्तरार्ध, लीळाचरित्र, leelacharitra Uttarardha, leelacharitra uttarardha, leelacharitra adnyat, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Uttarardha_charitra;
      this.title = "लीळाचरित्र उत्तरार्ध";
    }
    else if (type == "adnyat") {
      this.metaManager.updateMetaTitle("लीळाचरित्र अज्ञत | Mahanubhav Leelacharitra Adnyat | sarvadhnya.com",
        "Mahanubhav Panth Leelacharitra (लीळाचरित्र अज्ञत) - Easy access to Leelacharitra books, read online, search by any keyword",
        "लीळाचरित्र अज्ञत, लीळाचरित्र, leelacharitra adnyat, leelacharitra uttarardha, leelacharitra adnyat, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Adnyat_charitra;
      this.title = "लीळाचरित्र अज्ञत";
    }
    else if (type == "shrikrushna") {
      this.metaManager.updateMetaTitle("श्रीकृष्ण चरित्र | Mahanubhav Shri Krushna Charitra | sarvadhnya.com",
        "Mahanubhav Panth Shri Krushna Charitra (श्रीकृष्ण चरित्र) - Easy access to Shri Krushna Charitra books, read online, search by any keyword",
        "श्रीकृष्ण चरित्र, कृष्ण चरित्र, Mahanubhav Shri Krushna Charitra, Shri Krushna Charitra, Krushna Charitra, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Sri_Krushna_charitra;
      this.title = "श्रीकृष्ण चरित्र";
    }
    else if (type == "shridatta") {
      this.metaManager.updateMetaTitle("श्री दत्तात्रेय चरित्र | Mahanubhav Shri Datta Charitra | sarvadhnya.com",
        "Mahanubhav Panth Shri Datta Charitra (श्री दत्तात्रेय चरित्र) - Easy access to Shri Datta Charitra books, read online, search by any keyword",
        "श्री दत्तात्रेय चरित्र, दत्तात्रेय चरित्र, Mahanubhav Datta Charitra, Shri Datta Charitra, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Sahyandra_charitre;
      this.title = "श्री दत्तात्रेय चरित्र";
    }
    else if (type == "rpurvardha") {
      this.metaManager.updateMetaTitle("श्री गोविंद प्रभू चरित्र - पूर्वार्ध | Mahanubhav Shri Govind Prabhu (Ridhapur) Charitra | sarvadhnya.com",
        "Mahanubhav Panth Shri Govind Prabhu (Ridhapur) Charitra (श्री गोविंद प्रभू चरित्र - पूर्वार्ध) - Easy access to Shri Govind Prabhu (Ridhapur) Charitra books, read online, search by any keyword",
        "श्री गोविंद प्रभू चरित्र - पूर्वार्ध, श्री गोविंद प्रभू चरित्र, गोविंद प्रभू चरित्र, Mahanubhav Govind prabhu Charitra, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Ridhapur_charitra_purvardha;
      this.title = "श्री गोविंद प्रभू चरित्र - पूर्वार्ध";
    }
    else if (type == "ruttarardha") {
      this.metaManager.updateMetaTitle("श्री गोविंद प्रभू चरित्र - उत्तरार्ध | Mahanubhav Shri Govind Prabhu (Ridhapur) Charitra | sarvadhnya.com",
        "Mahanubhav Panth Shri Govind Prabhu (Ridhapur) Charitra (श्री गोविंद प्रभू चरित्र - उत्तरार्ध) - Easy access to Shri Govind Prabhu (Ridhapur) Charitra books, read online, search by any keyword",
        "श्री गोविंद प्रभू चरित्र - उत्तरार्ध, श्री गोविंद प्रभू चरित्र, गोविंद प्रभू चरित्र, Mahanubhav Govind prabhu Charitra, Mahanubhav book, Mahanubhav leelacharitra, leelacharitra, chakradhar swami leela, Mahanubhav Sahitya, Mahanubhav download, Read Leela Online");
      this.input.ltype = Ltype.Ridhapur_charitra_uttarardha;
      this.title = "श्री गोविंद प्रभू चरित्र - उत्तरार्ध";
    }
    this.get();
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    var h = 440;
    if (window.innerWidth <= 768)
      h = 1350;
    else if (window.innerWidth <= 992)
      h = 740;

    document.visibilityState
    if ((window.innerHeight + window.scrollY + h) >= document.body.offsetHeight) {
      if (!this.inProgress.getValue() && this.nextDataAvailable.getValue()) {
        console.log(this.input.pageNumber);
        this.input.pageNumber += 1;
        this.get();
      }
    }
  }

  get() {
    this.inProgress.next(true);
    var v = this.charitraService.get(this.input).pipe(
      map((root: Pagination) => {
        this.nextDataAvailable.next(root.remainingCount > 0);
        return root.content.map((x: LAccordion) => ({
          id: x.id,
          title: x.title,
          body: "<p><i class='bi bi-geo-alt-fill'></i> स्थान: "
            + x.sthan + ", जिल्हा: " + x.city + "</p>"
            + x.leela + "<br><br><i class='bi bi-pen-fill'></i> " + x.signiture
        } as AccordionVM))
      })
    ).subscribe(result => {
      var v = this.leelaLocal.getValue().concat(result);
      this.leelaLocal.next(v);
      this.inProgress.next(false);
    });
  }

  SearchText($event: string) {
    this.input.search = $event;
    this.leelaLocal.next([]);
    this.get();
  }
}

